import ApiService from '@/core/api/api.service';
import store from '@/store';

export default {
  search,
};

const dnaApi = new ApiService({
  baseUrl: store.getters.dnaBaseUrl,
  addAuthToken: false,
  headers: {
    Authorization: `Basic ${process.env.VUE_APP_DNA_AUTH_TOKEN}`,
  },
});

const countryConfigMapping = {
  default: {
    queryParams: {
      mm: '2<80%',
      rows: 5,
      defType: 'edismax',
      echoParams: 'none',
      fq: 'status:ACT',
      qf: 'vm_tradingNames_token^4 businessNames_token^3 tradingNames_token^2 vm_entityName_token entityName_token companyID',
    },
    buildSearchTerm: searchText => `${searchText}*`,
    mapping: entity => entity,
  },
  AU: {
    mapping: entity => ({
      address: [entity.state, entity.postCode, 'Australia'].filter(v => v).join(', '),
      businessName: entity.vm_tradingNames[0] || entity.vm_entityName || entity.businessNames[0] || entity.tradingNames[0] || entity.entityName,
      id: entity.companyID,
      uuid: entity.vm_vendor_uuid,
    }),
  },
  NZ: {
    mapping: (entity) => {
      const address3 = _.get(entity, 'physicalAddress.address3', [])[0] || _.get(entity, 'registeredAddress.address3', [])[0];
      const address2 = _.get(entity, 'physicalAddress.address2', [])[0] || _.get(entity, 'registeredAddress.address2', [])[0];
      const postcode = _.get(entity, 'physicalAddress.postCode', [])[0] || _.get(entity, 'registeredAddress.postCode', [])[0];
      const address = [address3 || address2, postcode, 'New Zealand'].filter(v => v).join(', ');
      return {
        address,
        businessName: entity.vm_tradingNames[0] || entity.vm_entityName || entity.tradingNames[0] || entity.entityName,
        id: entity.companyID,
        uuid: entity.vm_vendor_uuid,
      };
    },
  },
};

async function search(searchText, countryCode = 'AU') {
  const countryConfig = _.merge({}, countryConfigMapping.default, countryConfigMapping[countryCode] || {});

  const response = await dnaApi.get(`solr/${countryCode}/select`, {
    params: {
      ...countryConfig.queryParams,
      q: countryConfig.buildSearchTerm(searchText),
    },
  });

  return _.get(response, 'data.response.docs', []).map(countryConfig.mapping);
}
